<div>
    <button type="button" [disabled]="showAddworker?'true':null" mat-button class="addnewBtn" (click)="enable()" class="addnewbutton">{{workerLabel}}</button>
    <form #f="ngForm">
        <div *ngIf="showAddworker" class="md-input-container">

            <div layout="row" class="layout-row">
            <mat-form-field class="mat-form-withtooltip"  fxFlex="{{ showCompanyName ? 30: 45}}">
                <mat-label>First Name</mat-label>
                <input matInput [(ngModel)]="first_name" maxlength="200" name="first_name" maxlength="200" required>
            </mat-form-field>
            
    
            <mat-form-field class="mat-form-withtooltip" fxFlex="{{ showCompanyName ? 30: 45}}">
                <mat-label>Last Name</mat-label>
                <input matInput [(ngModel)]="last_name" maxlength="200" name="last_name" maxlength="200" required>
            </mat-form-field>

            <mat-form-field class="mat-form-withtooltip" fxFlex="30" *ngIf="showCompanyName">
                <mat-label>Business Name</mat-label>
                <input matInput [(ngModel)]="company_name" maxlength="200" name="company_name" maxlength="200" required>
            </mat-form-field>
        </div>
    
    
            <div layout="row" class="layout-row">
            <mat-form-field class="mat-form-withtooltip" fxFlex="55">
                <mat-label>Email</mat-label>
                <input matInput [(ngModel)]="email" maxlength="200" name="email" maxlength="200" required>
            </mat-form-field>
    
            <mat-form-field class="mat-form-withtooltip" fxFlex="35">
                <mat-label>Phone</mat-label>
                <input matInput [(ngModel)]="phone" maxlength="200" name="phone" maxlength="200" required>
            </mat-form-field>
    
        </div>
        </div>
    
    
        <div *ngIf="showAddworker">
            <button type="button" (click)="addWorker($event)" 
            [disabled]="!canProceed()"
            mat-button class="addnewbutton">{{saveWorkerLabel}}</button>
            <button type="button" (click)="cancelWorker($event)" mat-button class="ml-2" style="color: #248ae3;">Cancel</button>
        </div>
    </form>
</div>
